import { NgModule } from '@angular/core';

import { ModalForActiveOrderModule } from './forActiveOrder';
import { ModalForAdyenCVVModule } from './forAdyenCVV';
import { ModalForAlertModule } from './forAlert';
import { ModalForAuthModule } from './forAuth';
import { ModalForCreditCardAddModule } from './forCreditCardAdd';
import { ModalForDeliveryAddressModule } from './forDeliveryAddress';
import { ModalForDeliveryNotAvailableModule } from './forDeliveryNotAvailable';
import { ModalForDineInModule } from './forDineIn';
import { ModalForDeleteProfileModule } from './forDeleteProfile';
import { ModalForHistoryOrderModule } from './forHistoryOrder';
import { ModalForLoadingModule } from './forLoading';
import { ModalForLocationOpenHoursModule } from './forLocationOpenHours';
import { ModalForMemberCardModule } from './forMemberCard';
import { ModalForMenuFlowModule } from './forMenuFlow';
import { ModalForOrderTypesModule } from './forOrderTypes';
import { ModalForReorderModule } from './forReorder';
import { ModalForRewardModule } from './forReward';
import { ModalForScheduleModule } from './forSchedule';
import { ModalForSingleProductModule } from './forSingleProduct';
import { ModalForTransactionModule } from './forTransaction';
import { ModalForAddVoucherModule } from './forAddVoucher';

import { ModalViewComponent } from './modal-view.shared.component';

const toExportModules: any[] = [
    ModalForActiveOrderModule,
    ModalForAdyenCVVModule,
    ModalForAlertModule,
    ModalForAuthModule,
    ModalForCreditCardAddModule,
    ModalForDeliveryAddressModule,
    ModalForDeliveryNotAvailableModule,
    ModalForDineInModule,
    ModalForDeleteProfileModule,
    ModalForHistoryOrderModule,
    ModalForLoadingModule,
    ModalForLocationOpenHoursModule,
    ModalForMemberCardModule,
    ModalForMenuFlowModule,
    ModalForOrderTypesModule,
    ModalForReorderModule,
    ModalForRewardModule,
    ModalForScheduleModule,
    ModalForSingleProductModule,
    ModalForTransactionModule,
    ModalForAddVoucherModule
];

@NgModule({
    declarations: [
        ModalViewComponent,
    ],
    imports: [
        ...toExportModules,
    ],
    exports: [
        ModalViewComponent,
        ...toExportModules,
    ],
})
export class ModalsViewsModule { }
